import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { usePluginTranslation } from '@translation';
import FormHelperText from '@mui/material/FormHelperText';

interface AnomalyFormAssignedToHelperTextProps {
  isEmail: boolean;
  isValueInUsers: boolean;
  inputValue?: string;
}

export const AnomalyFormAssignedToHelperText = (props: AnomalyFormAssignedToHelperTextProps) => {
  const { inputValue, isEmail, isValueInUsers } = props;
  const { t } = usePluginTranslation();
  if (inputValue === '' || (isEmail && isValueInUsers)) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Icon component={InformationCircleIcon} fontSize="small" />
      {' '}
      <FormHelperText>
        {t('anomaly_plugin.widget.form.assigned_to.helper_message.text')}
      </FormHelperText>
    </Stack>
  );
};
